import { useNavigate } from 'react-router-dom';
import { useHasPermission } from '@/hooks/use-has-permission';
import { HRM_PERMISSIONS } from '@/constant/hr/permissions';
import { SERVICE_DESK_URLS } from '@/modules/service-desk/shared/service-desk.constants';
import { ServiceDeskPageShell } from '@/modules/service-desk/shared/components/service-desk-page-shell';
import { MetlifeMyApplications } from '../../components/metlife-my-applications/metlife-my-applications';
import { MetlifeRequests } from '../../components/metlife-requests/metlife-requests';

export const MetlifePage = () => {
  const navigate = useNavigate();
  const canViewRequests = useHasPermission(HRM_PERMISSIONS.METLIFE_APPLICATION.VIEW_REQUESTS);
  const canApply = useHasPermission(HRM_PERMISSIONS.METLIFE_APPLICATION.APPLY);

  return (
    <ServiceDeskPageShell
      titleKey="METLIFE_APPLICATION"
      requestsTabKey="METLIFE_REQUESTS"
      canViewRequests={canViewRequests}
      requests={<MetlifeRequests />}
      mine={<MetlifeMyApplications />}
      onApply={canApply ? () => navigate('/hr/service-desk/insurance/apply') : undefined}
      policyUrl={SERVICE_DESK_URLS.metlifePolicy}
    />
  );
};
